import React from "react";
import StepPlaceholder from "./StepPlaceholder";

interface StepProps {
  onBack: () => void;
  onNext: () => void;
}

const Step3Recipients: React.FC<StepProps> = ({
  onBack,
  onNext,
}) => {
  return (
    <StepPlaceholder
      step={3}
      label={
        <>
          Full Campaign <br /> Recipients
        </>
      }
      onBack={onBack}
      onNext={onNext}
    />
  );
};

export default Step3Recipients;
